import { render, staticRenderFns } from "./RegionFormModal.vue?vue&type=template&id=c117b8ec&scoped=true"
import script from "./RegionFormModal.vue?vue&type=script&lang=js"
export * from "./RegionFormModal.vue?vue&type=script&lang=js"
import style0 from "./RegionFormModal.vue?vue&type=style&index=0&id=c117b8ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c117b8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c117b8ec')) {
      api.createRecord('c117b8ec', component.options)
    } else {
      api.reload('c117b8ec', component.options)
    }
    module.hot.accept("./RegionFormModal.vue?vue&type=template&id=c117b8ec&scoped=true", function () {
      api.rerender('c117b8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/region/RegionFormModal.vue"
export default component.exports